import { AuthEndpoint } from './Auth';
export const templateEndpoint = new AuthEndpoint({
    path: '/encryptions/:fileId/template',
    method: 'GET'
});
